import { render, staticRenderFns } from "./PdoCardLayout.vue?vue&type=template&id=8bfa3a64"
import script from "./PdoCardLayout.vue?vue&type=script&lang=js"
export * from "./PdoCardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports